<template lang="pug">
  .error(v-if="error") {{ error === 500 ? 'Ресурс недоступен' : 'Ссылка некорректна'  }}. Обратитесь в техническую поддержку.
  DefaultLayout(v-else noLeftMenu noTopMenu)
    template(v-slot:header)
      ProjectDetail(v-if="project" :project="project" companyXl noAuth)
    .project-file-attach-list-page-ext(v-if="project")
      ProjectFileAttachList(
        :stages="stages"
        :tasks="tasks"
        :attaches="attaches"
        :project="project"
        external
      )
        template(#agreements)
          AgreementStatTiles(:items="agreements")
</template>

<script>
import projectFileAttachApi from '@/api/projectFileAttach';

import DefaultLayout from '@/layouts/Default.vue'
import ProjectDetail from '@/components/ProjectDetail.vue'
import ProjectFileAttachList from '@/components/project/ProjectFileAttachList.vue';
import AgreementStatTiles from '@/components/agreement/AgreementStatTiles.vue';


export default {
  components: { ProjectFileAttachList, DefaultLayout, ProjectDetail, AgreementStatTiles },
  data() {
    return {
      error: null,
      stages: [],
      tasks: {},
      attaches: [],
      project: null,
      agreements: [],
    };
  },
  async created() {
    const { extId, token } = this.$route.params;
    const data = await projectFileAttachApi.fetchExternal(extId, token, true).catch(e => { this.error = e.status; });

    this.agreements = data.agreements ?? [];

    this.project = data;
    data.stages.forEach((stage) => {
      stage.tasks.forEach((task, ti) => {
        this.attaches = [
          ...this.attaches,
          ...task.projectFileAttaches.map(a => ({ ...a, task: `${stage.id}-${ti}`})),
        ];

        const newTask = {
          '@id': `${stage.id}-${ti}`,
          name: task.name,
          sort: task.sort,
        };
        this.tasks[stage.id] = [...(this.tasks[stage.id] ?? []), newTask];
      });
      this.tasks[stage.id] = [...this.tasks[stage.id]].sort((a, b) => a.sort - b.sort);
      const progress = Math.floor(stage.numberOfClosedTasks / stage.numberOfTasks * 100);
      this.stages = [...this.stages, { ...stage, progress }];
    });

    this.stages = [...this.stages].sort((a, b) => a.sort - b.sort);
  },
};
</script>

<style lang="scss" scoped>
.project-file-attach-list-page-ext {
  width: 1400px;
  max-width: 95vw;
  margin: 0 auto;
  padding: 100px 0 0;
  display: flex;
  flex-direction: column;
  gap: 30px;

  h1 {
    font-weight: 700;
    color: var(--color-dark-gray);
    font-size: 40px;
    margin-bottom: 30px;
  }

  &__files {
    margin-top: 30px;
  }

  &__buttons {
    margin-top: 23px;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  &__upload-files {
    margin-right: auto;
  }

  @media (max-width: 1000px) {
    padding: 30px 0;
  }

  @media (max-width: 800px) {
    &__buttons {
      flex-direction: column;
    }

    &__upload-files {
      margin: 0;
    }
  }
}
</style>
